import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ISolicitudModel } from 'src/app/models/interfaces/ISolicitudModel';
import { SolicitudModel } from 'src/app/models/solicitud/SolicitudModel';
import { SolicitudService } from 'src/app/services/solicitud/solicitud.service';
import { ISolicitudDocumentoTecnicoModel } from 'src/app/models/interfaces/solicitud/documento-tecnico/ISolicitudDocumentoTecnicoModel';
import { SolicitudDocumentosTecnicosService } from 'src/app/services/solicitud-documentos-tecnicos/solicitud-documentos-tecnicos.service';
import * as fileSaver from 'file-saver';
import { PersonalReadonlyDialogComponent } from '../personal/personal-readonly-dialog/personal-readonly-dialog.component';
import { PersonalModel } from 'src/app/models/solicitud/PersonalModel';
import { EquipoModel } from 'src/app/models/solicitud/EquipoModel';
import { EquipoReadonlyDialogComponent } from '../equipo/equipo-readonly-dialog/equipo-readonly-dialog.component';
import { VehiculoModel } from 'src/app/models/solicitud/VehiculoModel';
import { VehiculoReadonlyDialogComponent } from '../vehiculo/vehiculo-readonly-dialog/vehiculo-readonly-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { LogDialogComponent } from '../../shared/log-dialog/log-dialog.component';
import { Location } from '@angular/common';
import { SolicitudPersonaService } from 'src/app/services/solicitud-persona/solicitud-persona.service';
import { EstadoSolicitud, Roles, SolicitudSeccion, eTypeResult } from 'src/app/models/common/enumModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudEquipoService } from 'src/app/services/solicitud-equipo/solicitud-equipo.service';
import { SolicitudVehiculoService } from 'src/app/services/solicitud-vehiculo/solicitud-vehiculo.service';
import { SolicitudDocumentoTecnicoModel } from 'src/app/models/solicitud/SolicitudDocumentoTecnicoModel';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';
import { VisorPdfDialogComponent } from '../../shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { SolicitudAdicionarInfoComponent } from '../solicitud-adicionar-info/solicitud-adicionar-info.component';
import { SolicitudAdicionarInfoModel } from 'src/app/models/solicitud/SolicitudAdicionarInfoModel';
@Component({
  selector: 'app-solicitud-detalle',
  templateUrl: './solicitud-detalle.component.html',
  styleUrls: ['./solicitud-detalle.component.css']
})
export class SolicitudDetalleComponent implements OnInit {
  model: ISolicitudModel = new SolicitudModel();
  id: number = 0;
  parentComponent = '';
  idTipoUsuario: number = 0;
  esSolicitante: boolean = false;
  esAdminSSO: boolean = false;

  estadosBorrarRegistrosEngie: number[] = [
    EstadoSolicitud.EN_REVISION,
    EstadoSolicitud.REVISADO,
    EstadoSolicitud.RECHAZADO,
    EstadoSolicitud.PROGRAMACION_INDUCCION,
    EstadoSolicitud.RESULTADOS_INDUCCION,
    EstadoSolicitud.AUTORIZACION_ACCESOS
  ]

  displayedColumnsPersonal: string[] = [
    'nombre',
    'dni',
    'cargo',
    'cantidad_documentos',
    'estado',
    'acciones'
  ];
  displayedColumnsEquipos: string[] = [
    // 'equipo',
    'marca',
    'modelo',
    'serie',
    'estado',
    'acciones'
  ];
  displayedColumnsVehiculos: string[] = [
    'marca',
    'modelo',
    'placa',
    'color',
    'anio',
    'chofer',
    'estado',
    'acciones'
  ];

  displayedColumnsDocumentacionTecnica: string[] = [
    'nombre',
    'idRequisito',
    'fechaVencimiento',
    'idDocumento',
    'acciones'
  ];

  constructor(
    private storageService: StorageService,
    private route: ActivatedRoute,
    private solicitudService: SolicitudService,
    private solicitudPersonaService: SolicitudPersonaService,
    private solicitudEquipoService: SolicitudEquipoService,
    private solicitudVehiculoService: SolicitudVehiculoService,
    private alertDialogService: AlertDialogService,
    private confirmDialogService: ConfirmDialogService,
    private solicitudDocumentoTecnicoService: SolicitudDocumentosTecnicosService,
    public dialog: MatDialog,
    private router: Router,
    private location: Location,
  ) { }

  ngOnInit(): void {
    this.route.parent?.url.subscribe((urlPath) => {
      // console.log(urlPath.length);
      this.parentComponent = urlPath[urlPath.length - 1].path;
      // console.log(url);
    })

    let usuario = this.storageService.getCurrentUser();
    this.esSolicitante = usuario.selectedRoles.find(p => p === Roles.SOLICITANTE) ? true : false;
    this.esAdminSSO = usuario.selectedRoles.find(p => p === Roles.ADMINISTRADORSSO || p === Roles.ADMINISTRADOR ) ? true : false;
    this.idTipoUsuario = usuario.idTipo;

    this.route.params.subscribe((params) => {
      this.id = params['id'];
      this.getSolicitud();
    });

  }

  private getSolicitud() {
    this.solicitudService.getById(this.id).subscribe((data: SolicitudModel) => {
      this.model = data;
      this.model.idSedeSelected = this.model.idSede;
      this.model.idTipoVisitaSelected = this.model.idTipoVisita;
      this.model.logs = this.model.logs.filter(p => p.comentarios != "" && p.comentarios != null);
      this.model.logsDocumentacionTecnica = this.model.logsDocumentacionTecnica.filter(p => p.comentarios != "" && p.comentarios != null);
      this.model.puedeCambiarSolicitante = this.esAdminSSO && this.model.idEstado == EstadoSolicitud.FINALIZADO && this.isOldDate(this.model.fechaFin.toString())
    },
    (error) => {
      this.location.back() // Centralized error handling
    });
  }

  isOldDate(fechaElva: string): Boolean{
    let fecha=new Date(fechaElva);
    let current = new Date();
    current.setHours(0, 0, 0, 0)
    return fecha >= current;
  }

  openDialogPersonal(personal: PersonalModel): void {
    personal.idSolicitud = this.model.idSolicitud;
    personal.codigoSolicitud = this.model.codigo;

    const dialogRef = this.dialog.open(PersonalReadonlyDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: personal,
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  openDialogEquipo(equipo: EquipoModel): void {
    equipo.idSolicitud = this.model.idSolicitud;
    equipo.codigoSolicitud = this.model.codigo;

    const dialogRef = this.dialog.open(EquipoReadonlyDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: equipo,
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  openDialogVehiculo(vehiculo: VehiculoModel): void {
    vehiculo.idSolicitud = this.model.idSolicitud;
    vehiculo.codigoSolicitud = this.model.codigo;

    const dialogRef = this.dialog.open(VehiculoReadonlyDialogComponent, {
      width: '1000px',
      // data: { name: this.name, animal: this.animal}
      data: vehiculo,
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  back(): void {
    this.location.back()
  }

  deletePersona(element: PersonalModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud a ${element.nombres} ${element.apellidoPaterno} ${element.apellidoMaterno}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudPersonaService.eliminar(element.idSolicitudPersona).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteEquipo(element: EquipoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el equipo: ${element.equipo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudEquipoService.eliminar(element.idSolicitudEquipo).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteVehiculo(element: VehiculoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el vehículo: ${element.marca}-${element.modelo}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudVehiculoService.eliminar(element.idSolicitudVehiculo).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  deleteDocTecnico(element: SolicitudDocumentoTecnicoModel): void {
    this.confirmDialogService.open(`¿Está seguro de eliminar de la solicitud el archivo del documento: ${element.documento}?`); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudDocumentoTecnicoService.eliminar(element.idSolicitudDocumentoTecnico).subscribe((result) => {
          this.getSolicitud();
          if (result.type != eTypeResult.SUCCESS) {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  downloadDocumentFromService(element: ISolicitudDocumentoTecnicoModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.DocumentacionTecnica;
      modelVisor.idSolicitudDocumento = element.idSolicitudDocumentoTecnico;
      modelVisor.codigoSolicitud = this.model.codigo;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudDocumentoTecnicoService.downloadDocumento(
        this.model.codigo,
        element.idSolicitudDocumentoTecnico
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }

  EsValidoParaEnviar(): boolean {
    // console.log('personas' +this.itemSolicitud.personas.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    // console.log('equipos' +this.itemSolicitud.equipos.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    // console.log('vehiculos' +this.itemSolicitud.vehiculos.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);
    // console.log('Documentos tecnicos' + this.itemSolicitud.documentosTecnicos.filter(p => p.idEstado === EstadoSolicitudItem.OBSERVADO || p.idEstado === EstadoSolicitudItem.PENDIENTE).length);

    return (
      this.model.trabajo != '' && this.model.motivo != ''
    );
  }

  guardarHeader() {
    let mensaje = `¿Está seguro de actualizar los datos de la solicitud ${this.model.codigo}?`;
    if(this.model.puedeCambiarSolicitante){
      mensaje = `¿Está seguro de actualizar el responsable de la solicitud ${this.model.codigo}?`;
    }
    // console.log(this.model);
    this.confirmDialogService.open(mensaje); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        this.solicitudService.updateHeader(this.model).subscribe((result) => {
          if (result.type == eTypeResult.SUCCESS) {
            this.alertDialogService.open('La solicitud fue actualizada.');
            switch (this.parentComponent) {
              case 'solicitudes':
                this.router.navigate(['/solicitudes-engie']);
                break;
              case 'aprobacion':
                this.router.navigate(['/solicitudes/aprobacion']);
                break;
              case 'administracion':
                this.router.navigate(['/solicitudes/administracion']);
                break;
              case 'contratista':
                this.router.navigate(['/solicitudes-contratista']);
                break;
            }
          }
          else {
            this.alertDialogService.open(result.message);
          }
        });
      }
    });
  }

  adicionarinfo(){
    let adicionarModel = new SolicitudAdicionarInfoModel();
    adicionarModel.idSolicitud = this.model.idSolicitud;


    const dialogRef = this.dialog.open(SolicitudAdicionarInfoComponent, {
      width: '650px',
      // data: { name: this.name, animal: this.animal}
      data: adicionarModel,
    });

    dialogRef.afterClosed().subscribe((result) => { 
      this.router.navigate(['/solicitudes-engie']);});
  }
}
